import { SectionBackTitle, SectionTitle } from "@/components/_common/Sections";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Articles from "@/components/Articles";

const BlogSection = ({ text, length, routeMap }) => {
  return (
    <Section className="section">
      <SectionBackTitle suppressHydrationWarning> {text?.home.articles.backtitle}</SectionBackTitle>
      <SectionTitle suppressHydrationWarning>{text?.home.articles.title}</SectionTitle>

      <div className="articles">
        <ActualityLink className="text-right">
          <Link to={`${routeMap?.urls.articlesActuality}`}>
            {text?.home.articles.actuality}
          </Link>
        </ActualityLink>
        {/* Simplified fallback for SEO and hydration stability */}
        <Articles text={text} length={length} routeMap={routeMap} $columns />
      </div>
    </Section>
  );
};

export default BlogSection;
const ActualityLink = styled.div`
  text-align: right;
  margin-bottom: 5px;
  font-variant: small-caps;
  font-weight: bold;
  a {
    color: ${(props) => props.theme.colors.dark};
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Section = styled.section`
  width: 1400px;
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 12px;
  @media screen and (min-width: 768px) {
    padding: 16px 0;
  }
`;
